import { Box, Typography } from '@mui/material';

interface TooltipContentProps {
  label: string;
  description: string;
  // extraInfo?: React.ReactNode; // 추가 정보를 위한 확장 가능한 prop
}

export const TooltipContent = ({
  label,
  description,
}: // extraInfo,
TooltipContentProps) => (
  <Box sx={{ p: 1 }}>
    <Typography variant="subtitle2" sx={{ mb: 1 }}>
      {label}
    </Typography>
    <Typography variant="body2">{description}</Typography>
    {/* {extraInfo} */}
  </Box>
);
